export class CompanyId {
  constructor(public value: string) {}
}
